export function parseCsrfTokenFromPage(): string {
  const csrfToken = document.documentElement.getAttribute('data-csrf');

  if (!csrfToken) {
    throw new Error('No CSRF element available on page');
  }

  return csrfToken;
}
